export default {
  name: "ui-button",
  inheritAttrs: false,
  props: {
    width: { default: null },
    color: { type: String, default: "" },
    padding: { type: String, default: "" },
    active: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false }
  },
  render(h) {
    const isDisabled = this.disabled || Boolean(this.$attrs.disabled);
    const style = {};

    if (this.width !== null && this.width !== "") {
      const width = String(this.width);
      style.minWidth = /px|%|rem|em$/.test(width) ? width : `${width}px`;
    }
    if (this.color) {
      style.backgroundColor = this.color;
    }
    if (this.padding) {
      style.padding = this.padding;
    }

    return h("div", {
      attrs: {
        ...this.$attrs,
        disabled: isDisabled
      },
      class: [
        "ui-button",
        {
          active: this.active,
          disabled: isDisabled
        },
        this.$attrs.class
      ],
      style,
      on: {
        ...this.$listeners,
        click: event => {
          if (isDisabled) {
            event.preventDefault();
            return;
          }
          this.$emit("onClick", event);
          this.$emit("click", event);
        }
      }
    }, [
      h("span", { class: "icon" }),
      this.$slots.default
    ]);
  }
};
